import React from 'react';
import { useAppContext } from '../../Store/Store';
import { isAnswerScreen } from '../Body/screenSequence';

export default function Header() {
  const {
    product,
    brand,
    style,
    logoRedirectUrl,
    event,
    resolveMediaUrl,
    currentScreenKey,
  } = useAppContext();

  // L'header e' condiviso da tutta la sequenza, ma la domanda del prodotto e la
  // sua presentazione (immagine prodotto, sizing multianswer) sono proprieta'
  // dello screen di risposta. Sugli altri screen della sequenza (consent,
  // device-data, photo-feedback, registration, codescanner, ...) non c'entrano
  // nulla: la', l'header torna quello standard, solo logo. Vedi isAnswerScreen.
  const onAnswerScreen = isAnswerScreen(currentScreenKey);

  const computedHeaderLogo =
    product?.header_logo || style?.header_logo || brand?.header_logo || '';
  const computedHeaderLogoUrl =
    product?.header_logo_url || logoRedirectUrl || '';
  const computedProductImg = onAnswerScreen
    ? product?.product_img ||
      (event?.use_product_placeholder_img && style?.product_placeholder_img) ||
      ''
    : '';
  const computedProductUrl =
    product?.product_img_url || style?.product_placeholder_url || '';
  const isProductMode = product && computedProductImg;
  const productQuestion = onAnswerScreen
    ? product?.product_indication || ''
    : '';
  const isMultianswerLayout =
    onAnswerScreen && !!product?.multianswer_selection;

  return (
    <header
      className="header-big"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'hidden',
        minHeight: isMultianswerLayout ? '30dvh' : undefined,
        maxHeight: isMultianswerLayout ? '40dvh' : undefined,
        marginTop: isMultianswerLayout ? 'clamp(8px, 2vh, 30px)' : undefined,
      }}
    >
      {/* User info and logout button */}
      {/*{userEmail && (
        <div style={{ 
          position: "absolute", 
          top: "10px", 
          right: "10px", 
          display: "flex", 
          alignItems: "center", 
          zIndex: 100 
        }}>
          <span style={{ 
            marginRight: "10px", 
            fontSize: "14px", 
            color: "#666" 
          }}>
            {userEmail}
          </span>
          <button
            onClick={handleLogout}
            style={{
              padding: "5px 10px",
              fontSize: "12px",
              fontWeight: "bold",
              color: "white",
              background: "linear-gradient(to right, #6991F8 0%, #07296a 100%)",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      )}*/}

      {isProductMode ? (
        <>
          <div className="logo-product-stack">
            <a
              className="logo-wrapper"
              href={computedHeaderLogoUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {computedHeaderLogo && (
                <img
                  src={resolveMediaUrl(computedHeaderLogo)}
                  alt="Header Logo"
                />
              )}
            </a>
            <div className="product-wrapper">
              {computedProductUrl ? (
                <a
                  href={computedProductUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    maxWidth: 'min(720px, 95%)',
                    maxHeight: '100%',
                    minWidth: 0,
                    minHeight: 0,
                    margin: '0 auto',
                  }}
                >
                  <img
                    src={resolveMediaUrl(computedProductImg)}
                    alt="Product"
                  />
                </a>
              ) : (
                <img src={resolveMediaUrl(computedProductImg)} alt="Product" />
              )}
            </div>
          </div>
          {productQuestion && (
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                padding: 'clamp(10px, 1.5vh, 16px) clamp(8px, 3vh, 24px)',
                color: style?.product_indication_text_color || 'grey',
                whiteSpace: 'normal',
                wordBreak: 'normal',
                overflowWrap: 'normal',
                fontSize: 'clamp(0.85rem, 2.2vh, 1rem)',
                lineHeight: 1.3,
                flex: '0 0 auto',
                boxSizing: 'border-box',
              }}
              dangerouslySetInnerHTML={{ __html: productQuestion }}
            />
          )}
        </>
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            padding: isMultianswerLayout
              ? '0 clamp(8px, 3vh, 24px) clamp(20px, 10vh, 80px)'
              : '0 clamp(8px, 3vh, 24px)',
          }}
        >
          <div
            style={{
              flex: '1 1 auto',
              minHeight: 0,
              minWidth: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <a
              href={computedHeaderLogoUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                maxWidth: 'min(35vh, 70vw, 360px)',
                maxHeight: 'min(35vh, 50vw, 360px)',
                minWidth: 0,
                minHeight: 0,
                margin: '0 auto',
              }}
            >
              {computedHeaderLogo && (
                <img
                  src={resolveMediaUrl(computedHeaderLogo)}
                  alt="Header Logo"
                  style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              )}
            </a>
          </div>
          {productQuestion && (
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                padding: 'clamp(4px, 1vh, 12px) 0',
                color: style?.product_indication_text_color || 'grey',
                whiteSpace: 'normal',
                wordBreak: 'normal',
                overflowWrap: 'normal',
                fontSize: 'clamp(0.85rem, 2.2vh, 1rem)',
                lineHeight: 1.3,
                flex: '0 0 auto',
              }}
              dangerouslySetInnerHTML={{ __html: productQuestion }}
            />
          )}
        </div>
      )}
    </header>
  );
}
